import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

function TermsModal({
  msgAlert,            // kept for interface parity (unused here)
  termsModal,
  closeTermsModal,
  quiz,
  setTermsAccepted,
  setStartGame
}) {
  const gameTerms = quiz?.[0]?.terms || null;

  // Safety: if there's no terms, auto-close and start the game
  useEffect(() => {
    if (termsModal && !gameTerms) {
      setTermsAccepted(true);
      setStartGame(true);
      closeTermsModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termsModal, gameTerms]);

  const renderhtml = (html) => ({ __html: html });

  const handleAccept = () => {
    setTermsAccepted(true);
    setStartGame(true);
    closeTermsModal();
  };

  // If there are no terms, render nothing (parent should keep `termsModal` false)
  if (!gameTerms) return null;

  return (
    <Modal show={termsModal} onHide={closeTermsModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Game Terms</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{ maxHeight: '500px', overflowY: 'auto' }}
          dangerouslySetInnerHTML={renderhtml(gameTerms)}
        />
        <div className="d-flex justify-content-center">
          <Button className="mt-3" variant="dark" onClick={handleAccept}>
            Accept Terms
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default TermsModal;
